const ALL_COLUMNS_VALUE = "*"
const FORMULA_ADDITIONAL_COLUMN_SEPARATOR = "::"
const ADDITIONAL_COLUMN_NORMALIZATION_EXCLUDED_COLUMNS = new Set(["Symbol"])
const DUPLICATED_CURVE_HEADER_SUFFIX_PATTERN = /^_[0-9]+$/ // Matches a base header with an optional generated numeric suffix, e.g. "FSB1" and "FSB1_2".
const TABLE_ADDITIONAL_COLUMN_SUFFIX_PATTERN = /^(.*?)(?:_(\d+))?$/

const getSelectedAdditionalColumns = ({ availableAdditionalColumns = [], columns = [] }) => {
  const selectedAdditionalColumns = (columns || [])
    .flatMap(item => Array.isArray(item) ? item : [item])
    .map(item => typeof item === "string" ? item : (item?.value || item?.label))
    .filter(Boolean)

  return selectedAdditionalColumns[0] === ALL_COLUMNS_VALUE ? availableAdditionalColumns : selectedAdditionalColumns
}

const getAvailableAdditionalColumnsFromRow = ({ row = [], fromIndex = 1 }) => (row || []).slice(fromIndex).filter((value, index, items) => value && items.indexOf(value) === index)

const getNormalizedCurveTableHeaders = ({ additionalColumns = [], rows = [] }) => {
  const firstRow = rows?.[0] || [],
        secondRow = rows?.[1] || [],
        normalizedHeaders = [],
        occurrencesByBaseHeader = {}
  let previousBaseHeader

  firstRow.forEach((rawHeader, columnIndex) => {
    if(columnIndex === 0) {
      normalizedHeaders.push(rawHeader)
      previousBaseHeader = rawHeader
      return
    }

    const baseHeader = rawHeader && !DUPLICATED_CURVE_HEADER_SUFFIX_PATTERN.test(String(rawHeader)) ? rawHeader : previousBaseHeader

    previousBaseHeader = baseHeader
    occurrencesByBaseHeader[baseHeader] = occurrencesByBaseHeader[baseHeader] || 0

    const currentOccurrenceIndex = occurrencesByBaseHeader[baseHeader]
    const additionalColumnName = !ADDITIONAL_COLUMN_NORMALIZATION_EXCLUDED_COLUMNS.has(baseHeader) ? (additionalColumns[currentOccurrenceIndex] || secondRow[columnIndex]) : undefined

    occurrencesByBaseHeader[baseHeader] += 1

    normalizedHeaders.push(baseHeader && additionalColumnName ? `${baseHeader}${FORMULA_ADDITIONAL_COLUMN_SEPARATOR}${additionalColumnName}` : baseHeader)
  })

  return normalizedHeaders
}

const getNormalizedTableColumnsAndData = ({ additionalColumns = [], columns = [], data = [], shouldNormalizeAdditionalColumns = false }) => {
  const firstRow = data?.[0] || {}
  const availableAdditionalColumns = getAvailableAdditionalColumnsFromRow({
    row: columns.slice(1).map(column => firstRow?.[column]),
    fromIndex: 0
  })
  const normalizedAdditionalColumns = getSelectedAdditionalColumns({ availableAdditionalColumns, columns: additionalColumns })
  const shouldNormalize = shouldNormalizeAdditionalColumns && normalizedAdditionalColumns.length > 1

  if(!shouldNormalize) {
    return {
      columns,
      data
    }
  }

  const fieldsMap = {}

  const normalizedColumns = (columns || []).map(column => {
    const match = String(column || '').match(TABLE_ADDITIONAL_COLUMN_SUFFIX_PATTERN),
          baseColumn = match?.[1] || column,
          suffixIndex = match?.[2] === undefined ? 0 : Number(match[2]),
          additionalColumnName = !ADDITIONAL_COLUMN_NORMALIZATION_EXCLUDED_COLUMNS.has(baseColumn) ? normalizedAdditionalColumns[suffixIndex] : undefined,
          normalizedColumn = additionalColumnName ? `${baseColumn}${FORMULA_ADDITIONAL_COLUMN_SEPARATOR}${additionalColumnName}` : column

    fieldsMap[column] = normalizedColumn

    return normalizedColumn
  })

  const normalizedData = (data || []).map(row => Object.fromEntries(Object.entries(row || {}).map(([column, value]) => [fieldsMap[column] || column, value])))

  return { columns: normalizedColumns, data: normalizedData }
}

export default {
  ADDITIONAL_COLUMN_NORMALIZATION_EXCLUDED_COLUMNS,
  ALL_COLUMNS_VALUE,
  FORMULA_ADDITIONAL_COLUMN_SEPARATOR,
  getAvailableAdditionalColumnsFromRow,
  getNormalizedCurveTableHeaders,
  getNormalizedTableColumnsAndData,
  getSelectedAdditionalColumns
}
